import { Avatar, Box, IconButton, Menu, MenuItem, Tooltip, Typography } from "@mui/material";
import * as React from 'react';
import { useNavigate } from "react-router-dom";
import { auth } from "../config/firebase";
import { signOut } from "firebase/auth"
import {useContext} from 'react';
import {AuthContext} from '../contexts/authContext';

export const ProfilMenuItem = (props) => {
    const [anchorElUser, setAnchorElUser] = React.useState(null);
    const { user, logOut } = useContext(AuthContext);

    const navigate = useNavigate();

    const handleOpenUserMenu = (event) => {
        setAnchorElUser(event.currentTarget);
    };

    const handleCloseUserMenu = () => {
        setAnchorElUser(null);
    };

    const handleMyProjects = () => {
        navigate("/myprojects");
    };

    const handleUser = () => {
        navigate("/user");
    };

    const handleLogOut = async () => {
        try {
            await logOut();
            navigate("/");
            } catch (err){
              console.error(err);
            }
    };

    return (
        <>
            <Box sx={{ flexGrow: 1 }}></Box>
            <Box sx={{ flexGrow: 0 }}>
                <Tooltip title="Open settings">
                    <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }}>
                        <Avatar alt={props.userData?.name} src={props.userData?.picurl} />
                    </IconButton>
                </Tooltip>
                <Menu
                    sx={{ mt: '45px' }}
                    id="menu-appbar"
                    anchorEl={anchorElUser}
                    anchorOrigin={{
                        vertical: 'top',
                        horizontal: 'right',
                    }}
                    keepMounted
                    transformOrigin={{
                        vertical: 'top',
                        horizontal: 'right',
                    }}
                    open={Boolean(anchorElUser)}
                    onClose={handleCloseUserMenu}
                >
                    <MenuItem key="myprojects" onClick={handleMyProjects}>
                        <Typography textAlign="center">My Projects</Typography>
                    </MenuItem>
                    <MenuItem key="profile" onClick={handleUser}>
                        <Typography textAlign="center">Profile</Typography>
                    </MenuItem>
                    <MenuItem key="logout" onClick={handleLogOut}>
                        <Typography textAlign="center">Logout</Typography>
                    </MenuItem>
                </Menu>
            </Box>
        </>
    );
}